import FormToJSON from './form-to-json';
import Ping from './ping';

export default class AddFavourite {
	constructor({ elements }) {
		elements.forEach((el) => {
			el.addEventListener('click', (e) => {
				e.preventDefault();
				this.renderPopUp(el.dataset.addFavourite);
			});
		});
	}

	renderPopUp(projectTemplateKey) {
		document.querySelector('.lightbox__container').classList.remove('is-open');
		window.dispatchEvent(
			new CustomEvent('lightbox-show-by-template-id', {
				detail: {
					templateId: 'favouritesPopUp',
				},
			})
		);
		this.form = document.getElementById('submitFavourite');
		this.submitBtn = document.getElementById('popupSubmit');
		this.submitBtn.addEventListener('click', (e) => {
			e.preventDefault();
			this.submitBtn.disabled = true;
			this.json = FormToJSON(this.form);
			if (!this.json.Key || this.json.Key === '00000000-0000-0000-0000-000000000000') {
				this.json.Key = projectTemplateKey;
			}
			if (this.checkRadioInputs(this.form)) {
				this.submitFavourite(this.json);
				window.dispatchEvent(new CustomEvent('lightbox-close'));
			}
		});
	}

	checkRadioInputs(form) {
		this.checkedInputs = form.querySelectorAll('input[type="radio"]:checked').length;
		if (this.checkedInputs <= 0) {
			form.querySelectorAll('input[type="radio"]').forEach((el) => {
				el.classList.add('input--error', 'invalid');
			});
			document.getElementById('NoRadioInputSelected').classList.remove('error-msg--hidden');
			return false;
		}
		return true;
	}

	static changeFavouritesText(projectTemplateKey) {
		const addToFavourites = document.getElementById('addToFavourites');
		const addedToFavourites = document.getElementById('addedToFavourites');

		if (addToFavourites !== null && addedToFavourites !== null) {
			addToFavourites.classList.add('hidden');
			addedToFavourites.classList.remove('hidden');
			return;
		}

		const projectTemplates = document.querySelectorAll('.favourite-selection');
		projectTemplates.forEach((el) => {
			if (el.dataset.templateKey === projectTemplateKey) {
				el.classList.add('hidden');
			}
		});

		const favoritedProjectTemplates = document.querySelectorAll('.favourited-selection');
		favoritedProjectTemplates.forEach((el) => {
			if (el.dataset.templateKey === projectTemplateKey) {
				el.classList.remove('hidden');
			}
		});
	}

	async submitFavourite(form) {
		this.baseUrl = '/umbraco/api/FavouriteApi';
		await fetch(`${this.baseUrl}/SubmitFavourite`, {
			body: JSON.stringify(form),
			headers: { 'Content-Type': 'application/json', Culture: document.documentElement.lang },
			method: 'POST',
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error();
				}
				return response.json();
			})
			.then((data) => {
				if (data.responseContent) {
					AddFavourite.changeFavouritesText(form.Key);
				}
				Ping.createHappyPing(
					data?.ping?.pingHeading,
					data?.ping?.pingBody,
					data?.ping?.pingEmotion
				);
			})
			.catch((data) => {
				if (data !== null) {
					Ping.createSadPing(
						data?.ping?.pingHeading,
						data?.ping?.pingBody,
						data?.ping?.pingEmotion
					);
				}
			});
	}
}
